import "./Instructivo.css";
import { useEsMovil } from "./useEsMovil";
export default function Instructivo() {
  const esMovil = useEsMovil();
  return (
    <>
      <div className="Instructivo__container">
        <h2>
          Visitá los misteriosos túneles históricos <br></br>de la Manzana de
          las Luces
        </h2>
        <div>
          <p>
            📅 <b>Días y horarios:</b>
          </p>
          <p>Sábados y domingos, de 15 a 18 hs. ⏰</p>
          <p>
            📍 <b>Dirección:</b> Perú 222, Buenos Aires. 🗺️
          </p>
          <br></br>
          <p>
            🌧️ <b>¡La actividad no se suspende por lluvia!</b> ☔😊
          </p>
          <br></br>
          <p>
            🚀 <b>Experiencia:</b>
          </p>
          <ul>
            <li>
              Recorré con un <b>grupo reducido</b> (máx. 6 personas) 👥
            </li>
            <li>
              Duración: <b>15 minutos</b> ⏳
            </li>
            <li>
              <b>Solo para mayores de 16 años</b> ✅
            </li>
            <li>
              Acceso al <b>mirador de los túneles</b> 🕵️‍♂️🔍
            </li>
            <li>
              Descubrí la <b>vida antigua y secreta</b> de Buenos Aires 🗝️🏙️
            </li>
          </ul>
          <p>
            📝 <b>Requisitos importantes:</b>
          </p>
          <br></br>
          <p>
            ✅ seleccioná un turno, completá el formulario <br></br>
            &nbsp;&nbsp;&nbsp;y esperá la{" "}
            <b>confirmación que te llegará por email</b> 📨
          </p>
          <p>
            ✅ El día de la visita: <b>traé tu DNI físico</b> (los turnos son{" "}
            <b>intransferibles</b>) 🪪
          </p>
          <p>
            ✅ Llegá <b>10 minutos antes</b> de tu horario ⏱️
          </p>
          <p>
            ❌ <b>No se permite ingresar con alimentos ni bebidas</b> 🚫🍔🥤
          </p>
          <br></br>
          <p className="Instructivo__mail">
            tuneleshistoricosdemanzana@gmail.com
          </p>
        </div>
      </div>
    </>
  );
}
